import compose from 'lodash.flowright';

import { mapProps } from '../../../../../../../../../../util/hocs';
import withModal from '../../../../../../../../../../components/global/modal/withModal';
import AccountCardAlbumCustomPrintConfigurator from './AccountCardAlbumCustomPrintConfigurator';

const ACCOUNT_CARD_ALBUM_CUSTOM_PRINT_CONFIGURATOR_MODAL =
  'ACCOUNT_CARD_ALBUM_CUSTOM_PRINT_CONFIGURATOR_MODAL';

const AccountCardAlbumCustomPrintConfiguratorModal = withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(AccountCardAlbumCustomPrintConfigurator),
  {
    name: ACCOUNT_CARD_ALBUM_CUSTOM_PRINT_CONFIGURATOR_MODAL,
    dismissible: false,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    shouldCloseOnOverlayClick: false,
    className: 'account-card-custom-print-configurator-modal modal-contained',
  },
);

export default AccountCardAlbumCustomPrintConfiguratorModal;
